var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreatmentArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 23,
    viewBox: "0 0 64 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.654794 16.2418C0.374277 16.7175 0.532537 17.3306 1.00828 17.6111L8.76092 22.1824C9.23666 22.4629 9.84972 22.3047 10.1302 21.8289C10.4108 21.3532 10.2525 20.7401 9.77676 20.4596L2.88552 16.3962L6.94888 9.505C7.2294 9.02926 7.07114 8.4162 6.5954 8.13568C6.11966 7.85516 5.50659 8.01342 5.22607 8.48916L0.654794 16.2418ZM62.6075 2.01209C63.1423 1.87404 63.4639 1.32863 63.3258 0.793877C63.1878 0.259122 62.6424 -0.0624743 62.1076 0.0755691L62.6075 2.01209ZM1.76615 17.718L62.6075 2.01209L62.1076 0.0755691L1.26625 15.7815L1.76615 17.718Z",
    fill: "#00285B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatmentArrow);
export default __webpack_public_path__ + "static/media/TreatmentArrow.b120823648b6da37a4e0544b6320d04e.svg";
export { ForwardRef as ReactComponent };